import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ManageInactiveScreensInfo = ({ open, setOpen, user }) => {
	const navigate = useNavigate();

	const handleBuy = () => {
		if (user?.plan?.paid) {
			navigate(`/user-details/${user?._id}#mysubscriptions`);
		} else {
			navigate(`/user-details/${user?._id}#mysubscriptionsfl`);
		}
		setOpen(false);
	};

	return (
		<Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
			<DialogContent>
				<DialogContentText>
					You&apos;re able to switch screen&apos;s status only once. To unlock screen(s) buy new ones.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" color="error" onClick={() => setOpen(false)}>
					Cancel
				</Button>
				<Button variant="contained" color="success" onClick={handleBuy}>
					Buy
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ManageInactiveScreensInfo;
